import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { PriceDisplay } from 'dibs-buyer-price';
import { FormattedMessage } from 'dibs-react-intl';
import { PdpSharedAuctionViewHistory } from '../PdpSharedAuctionViewHistory/PdpSharedAuctionViewHistory';

// types
import { PdpSharedAuctionClosed_item$key as Item } from './__generated__/PdpSharedAuctionClosed_item.graphql';

// styles
import styles from './PdpSharedAuctionClosed.scss';

type Props = {
    item: Item;
    currency: string;
    linkToBidHistory?: boolean;
};

const itemFragment = graphql`
    fragment PdpSharedAuctionClosed_item on Item {
        ...PriceDisplay_item
            @arguments(userId: $userId, isTrade: $isTrade, userCountryCode: $userCountryCode)
    }
`;

export const PdpSharedAuctionClosed: FC<Props> = ({
    item: itemRef,
    currency,
    linkToBidHistory,
}) => {
    const item = useFragment(itemFragment, itemRef);

    return (
        <div className={styles.container}>
            <span className={styles.closed} data-tn="pdp-bidding-closed">
                <FormattedMessage
                    id="PdpSharedAuctionClosed.biddingClosed"
                    defaultMessage="Bidding Closed"
                />
            </span>
            <span className={styles.price}>
                <PriceDisplay currency={currency} item={item} useSvgIcon />
            </span>
            {linkToBidHistory && <PdpSharedAuctionViewHistory currency={currency} />}
        </div>
    );
};
